// extracted by mini-css-extract-plugin
export default {"large":"LikeIconButton_large__gTfhJ","container":"LikeIconButton_container__BFP9V"};